import { IApplicationState } from '../../types/redux';
import { DEFAULT_DEADLINE_VALUE } from '../../reducers/filter';
import { getFilters } from './getFilters';

export function getDeadline(state: IApplicationState) {
  const filters = getFilters(state);

  return filters.deadline;
}

export function getDeadlineVariants(state: IApplicationState) {
  const filters = getFilters(state);

  return filters.deadlineVariants;
}

export function getDeadlineVariantsForSelect(state: IApplicationState) {
  const filters = getFilters(state);
  const options = filters.deadlineVariants.map(variant => ({ value: variant, label: `До конца ${variant}` }));

  return [{ label: 'Не важно', value: DEFAULT_DEADLINE_VALUE }, ...options];
}
